/* C-04 Itinerary row and the leg between rows. */
.row {
  position: relative;
  display: grid;
  grid-template-columns: 3.25rem 1.25rem minmax(0, 1fr) auto;
  column-gap: var(--dimension-space-3);
  align-items: start;
  padding: var(--dimension-space-3) 0 var(--dimension-space-3) calc(3px + var(--dimension-space-3));
}
/* The accent bar (M-02) only marks now/next on today's plan. */
.now::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--color-accent-indicator);
}
.time {
  display: grid;
}
.zone {
  color: var(--color-text-tertiary);
}
.now .time > :first-child {
  font-weight: 700;
}
.chip {
  display: grid;
  place-items: center;
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 1px;
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.chip svg {
  width: 0.75rem;
  height: 0.75rem;
}
.text {
  display: grid;
  gap: 2px;
  min-width: 0;
}
.title,
.subline {
  min-width: 0;
  margin: 0;
  overflow-wrap: break-word;
}
.subline {
  color: var(--color-text-secondary);
}
.tags {
  margin-top: 4px;
}
/* Logged expenses and sub-items: outline chip; sub-items sit closer under their parent. */
.logged .chip,
.sub .chip {
  background: transparent;
  color: var(--color-text-primary);
  box-shadow: inset 0 0 0 var(--dimension-line-hairline) var(--color-text-primary);
}
.sub .chip {
  width: 1.125rem;
  height: 1.125rem;
  justify-self: center;
}
.logged .title {
  font-weight: 700;
}
.sub .title {
  font-weight: 500;
}
.sub {
  padding-top: var(--dimension-space-1);
}
.side {
  display: grid;
  gap: var(--dimension-space-1);
  justify-items: end;
}
.stop {
  color: var(--color-text-tertiary);
}
.past .title,
.past .time {
  color: var(--color-text-secondary);
}

.inlineTime {
  display: none;
}

.leg {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-2);
  padding-left: calc(3px + var(--dimension-space-3) + 3.25rem + var(--dimension-space-3) + 0.5625rem);
  color: var(--color-text-secondary);
}
.legLine {
  width: 1px;
  height: 18px;
  background: var(--color-border-hairline);
}
.leg svg {
  width: 0.75rem;
  height: 0.75rem;
}

/* Narrow or zoomed: the time joins the text column and the money drops under it. */
@media (max-width: 21.25em) {
  .row {
    grid-template-columns: 1.25rem minmax(0, 1fr) auto;
    column-gap: var(--dimension-space-2);
  }
  .leg {
    padding-left: calc(3px + var(--dimension-space-3) + 0.5625rem);
  }
  .row > .time {
    display: none;
  }
  .inlineTime {
    display: grid;
  }
}
